import * as constants from './constants';

export const getBrowseItems = () => ({ type: constants.GET_BROWSE_ITEMS });
export const getBrowseItemsSuccess = (payload) => ({
  type: constants.GET_BROWSE_ITEMS_SUCCESS,
  payload,
});
export const getBrowseItemsError = (payload) => ({
  type: constants.GET_BROWSE_ITEMS_ERROR,
  payload,
});

export const selectItem = (payload) => ({ type: constants.SELECT_BROWSE_ITEM, payload });
export const deselectItem = (payload) => ({ type: constants.DESELECT_BROWSE_ITEM, payload });
export const deselectMany = (payload) => ({
  type: constants.DESELECT_MANY_BROWSE_ITEMS,
  payload,
});
export const resetBrowseItems = () => ({ type: constants.RESET_BROWSE_ITEMS });
export const resetBrowseItemsActions = () => ({ type: constants.RESET_BROWSE_ITEMS_ACTIONS });
export const openBrowseItem = (payload) => ({ type: constants.OPEN_BROWSE_ITEM, payload });
export const closeBrowseItem = () => ({ type: constants.CLOSE_BROWSE_ITEM });

export const setBrowseItemsFilters = (payload) => ({
  type: constants.SET_BROWSE_ITEMS_FILTERS,
  payload,
});

export const getBrowseItemsDebaunced = (payload) => ({ type: constants.GET_BROWSE_ITEMS_DELAYED, payload });

export const updateBrowseItems = (payload) => ({
  type: constants.UPDATE_BROWSE_ITEMS,
  payload,
});
